import { CLOSE_ALL_DIALOGS_EVENT } from '@colonist/ui';
export class UIPopupManager {
    static trackPopup(popup) {
        UIPopupManager.activePopups.push(popup);
    }
    static untrackPopup(popupToRemove) {
        UIPopupManager.activePopups = UIPopupManager.activePopups.filter((popup)=>popup != popupToRemove);
    }
    static isPopupTracked(popupToFind) {
        const popupFound = UIPopupManager.activePopups.find((popup)=>popup == popupToFind);
        return popupFound == undefined ? false : true;
    }
    static closeAllPopups() {
        UIPopupManager.removeActivePopups();
        window.dispatchEvent(new Event(CLOSE_ALL_DIALOGS_EVENT));
    }
    static removeActivePopups() {
        UIPopupManager.activePopups.forEach((popup)=>{
            popup.removePopup();
        });
    }
}
UIPopupManager.activePopups = [];
